import { Injectable } from '@angular/core';
import { SessionRepository } from '@frontend-site/shared/core';
import { SystemInfo, SystemTypes } from '@frontend-site/shared/data';
import { LocalStoragePersister } from '../../infrastructure/local-storage-persister';

const PERSISTENCE_KEY = 'last_system';

@Injectable({ providedIn: 'root' })
export class LastSystemService {
    constructor(private readonly session: SessionRepository, private readonly persister: LocalStoragePersister<number>) {}

    set(systemId: number): void {
        this.setLastSystem(systemId);
    }

    get(): SystemInfo | null | undefined {
        const lastSystem = this.persister.get(PERSISTENCE_KEY);
        if (lastSystem) {
            return this.session.applicationConfig?.systems.find((s) => s.id === lastSystem);
        }

        return null;
    }

    getBySystemType(systemType: SystemTypes): SystemInfo | null | undefined {
        const system = this.get();
        if (system && system.systemType === SystemTypes[systemType]) {
            return system;
        }

        return this.session.applicationConfig?.systems.find((s) => s.systemType === SystemTypes[systemType]);
    }

    private setLastSystem(systemId: number): void {
        this.persister.set(PERSISTENCE_KEY, systemId);
    }
}
